import {NgModule} from '@angular/core';
import {ProductRepository} from './impl/service/ngrx-data/product.repository';
import {ProductDataServiceAdapter} from './impl/service/ngrx-data/productDataService.adapter';
import {ProductDeliveredModule} from './delivered/product-delivered.module';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ProductDataService} from './impl/service/ngrx-data/productData.service';
import {errorMessages} from '../core/error/errorMessages';
import {ProductSummaryDataServiceAdapter} from './impl/service/ngrx-data/productSummaryDataService.adapter';
import {ProductSummaryConverter} from './api/entity/converter/productSummary.converter';
import {ProductConverter} from './api/entity/converter/product.converter';
import {ProductRetrocessionModule} from './retrocession/product-retrocession.module';
import {ProductStockUnitModel} from "./stock/unit/api/entity/productStockUnit.model";
import {ProductStockUnitModule} from "./stock/unit/productStockUnit.module";

@NgModule({
    providers: [
        ProductRepository,
        ProductDataService,
        ProductDataServiceAdapter,
        ProductSummaryDataServiceAdapter,

        ProductSummaryConverter,
        ProductConverter,
    ],
    imports: [
        ProductDeliveredModule,
        ProductRetrocessionModule,
        ProductStockUnitModule
    ]
})
export class ProductModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                service: ProductRepository,
                dataService: ProductDataService,
    ) {

        entityDataService.registerServices({
            Product: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Product: service,
        });

        errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
